module.exports = __webpack_public_path__ + "img/live-status-icon-animation.efca78e5.gif";